(function($) {
	'use strict';

	var FlashMessenger, FlashMessage;


	/**
	 * FlashMessenger object
	 */
	FlashMessenger = function() {
		this.container = $('flash-message-container');
		this.config = {
			success: {
				autoCloseDelay: 5000
			},
			info: {
				autoCloseDelay: 5000
			},
			error: {
				autoCloseDelay: false
			},
			warning: {
				autoCloseDelay: false
			}
		};
		this.list = [];
		this._init();
	};


	/**
	 * FlashMessage object
	 * @param {object}  $element       jQuery object of HTML element <flash-message>
	 * @param {integer} autoCloseDelay count of miliseconds or false
	 */
	FlashMessage = function($element, autoCloseDelay) {
		this.element = $element;
		this.autoCloseTimer;
		this.autoCloseDelay = autoCloseDelay;
		this.closeDelay = 300;
		this._init();
	};


	/**
	 * @public
	 * @param   {string} flashMessage HTML element <flash-message>
	 * @returns {this}
	 */
	FlashMessenger.prototype.addFlashMessage = function(flashMessage) {
		var $flashMessage, autoCloseDelay;

		$flashMessage = $(flashMessage);
		autoCloseDelay = this.config[$flashMessage.data('type')].autoCloseDelay;

		this.list.push(new FlashMessage($flashMessage, autoCloseDelay));
		this.container.prepend($flashMessage);

		return this;
	};


	/**
	 * @public
	 * @param   {string}  content              text of flash message
	 * @param   {string}  type                 [info, success, error, warning]
	 * @param   {integer} customAutoCloseDelay count of miliseconds or false
	 * @returns {this}
	 */
	FlashMessenger.prototype.createFlashMessage = function(content, type, customAutoCloseDelay) {
		var template, $flashMessage, autoCloseDelay;

		template = '<flash-message data-type="' + type + '"><div><content>' + content + '</content>'
			+ '<control class="close"></control></div></flash-message>';
		$flashMessage = $(template);

		if (customAutoCloseDelay !== undefined) {
			autoCloseDelay = customAutoCloseDelay;
		}
		else {
			autoCloseDelay = this.config[$flashMessage.data('type')].autoCloseDelay;
		}

		this.list.push(new FlashMessage($flashMessage, autoCloseDelay));
		this.container.prepend($flashMessage);

		return this;
	};


	/**
	 * @public
	 * @returns {this}
	 */
	FlashMessage.prototype.close = function() {
		var flashMessage = this;

		flashMessage.element.addClass('closing');
		setTimeout(function() {
			flashMessage.element.addClass('closed').removeClass('closing');
		}, flashMessage.closeDelay);

		return this;
	};


	/**
	 * @private
	 * @returns {undefined}
	 */
	FlashMessenger.prototype._init = function() {
		var flashMessenger = this;

		$('flash-message').each(function() {
			var $flashMessage, autoCloseDelay;

			$flashMessage = $(this);
			autoCloseDelay = flashMessenger.config[$flashMessage.data('type')].autoCloseDelay;

			flashMessenger.list.push(new FlashMessage($flashMessage, autoCloseDelay));
		});
	};


	/**
	 * @private
	 * @returns {undefined}
	 */
	FlashMessage.prototype._init = function() {
		var flashMessage = this;

		flashMessage.element.find('control.close').click(function(event) {
			if (typeof navigator === 'object' && typeof navigator.vibrate === 'function') {
				navigator.vibrate(35);
			}

			clearTimeout(flashMessage.autoCloseTimer);
			flashMessage.close();
			event.preventDefault();

			return false;
		});

		if (flashMessage.autoCloseDelay !== false) {
			flashMessage.autoCloseTimer = setTimeout(function() {
				flashMessage.close();
			}, flashMessage.autoCloseDelay);
		}
	};


	$.flashMessenger = new FlashMessenger();

}(jQuery));